var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "realtime-overview" },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header flex align-center" }, [
          _c("a", { staticClass: "pointer title mar-r5" }, [
            _c("span", [_vm._v("实时概况")])
          ]),
          !_vm.isClick
            ? _c(
                "div",
                { staticClass: "pointer flex items-center" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "bottom",
                        effect: "dark",
                        content: _vm.tooltip
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning-outline gray6 f18 mar5-l"
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c(
        "ul",
        { staticClass: "ul-cls class" },
        _vm._l(_vm.nav, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              class: { active: _vm.navIndex === index },
              on: {
                click: function($event) {
                  return _vm.navChange(index)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(item) + "\n    ")]
          )
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "content"
        },
        [
          _c(
            "div",
            { staticClass: "left" },
            [
              _vm.isShowChart
                ? [
                    _c("div", { staticClass: "left-title" }, [
                      _vm._v("近30天趋势")
                    ]),
                    _c("div", { ref: "chart", staticClass: "left-chart" })
                  ]
                : _vm._e(),
              !_vm.isClick
                ? [
                    !_vm.salesAuthority
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex height-full items-center justify-center fb f16 gray9"
                          },
                          [_vm._v("您暂无权限查看，请联系管理员")]
                        )
                      : !_vm.shopId || _vm.defaultShop.audit !== 1
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex height-full items-center justify-center fb f16 gray9"
                          },
                          [
                            _vm._v(
                              "\n          您暂未拥有店铺或店铺未审核通过\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm.navIndex === 0
            ? _c("div", { staticClass: "right" }, [
                _vm.isClick
                  ? _c(
                      "div",
                      { staticClass: "blue text-center right-amount" },
                      [
                        _c("span", { staticClass: "right-amount-symbol" }, [
                          _vm._v("￥")
                        ]),
                        _c(
                          "span",
                          { staticClass: "f-arial fb right-amount-num" },
                          [
                            _vm._v(
                              _vm._s(_vm.$moneyFormat(_vm.orderMoney.sumMoney))
                            )
                          ]
                        )
                      ]
                    )
                  : _c("div", { staticClass: "text-center right-amount" }, [
                      _vm._v("*****")
                    ]),
                _c("div", { staticClass: "gray6 text-center right-text" }, [
                  _vm._v("累计成交额（元）")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "gray6 right-items",
                    class: "items" + _vm.navIndex
                  },
                  [
                    _c("div", { staticClass: "item item0" }, [
                      _vm.isClick
                        ? _c("div", { staticClass: "item-amount" }, [
                            _c("div", { staticClass: "item-symbol" }, [
                              _vm._v("￥")
                            ]),
                            _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                _vm._s(_vm.$moneyFormat(_vm.orderMoney.today))
                              )
                            ])
                          ])
                        : _c("div", { staticClass: "item-amount" }, [
                            _vm._v("*****")
                          ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("今日成交金额")
                      ])
                    ]),
                    _c("div", { staticClass: "item item1" }, [
                      _vm.isClick
                        ? _c("div", { staticClass: "item-amount" }, [
                            _c("div", { staticClass: "item-symbol" }, [
                              _vm._v("￥")
                            ]),
                            _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$moneyFormat(_vm.orderMoney.yesterday)
                                  ) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _c("div", { staticClass: "item-amount" }, [
                            _vm._v("*****")
                          ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("昨日成交金额")
                      ])
                    ]),
                    _c("div", { staticClass: "item item2" }, [
                      _vm.isClick
                        ? _c("div", { staticClass: "item-amount" }, [
                            _c("div", { staticClass: "item-symbol" }, [
                              _vm._v("￥")
                            ]),
                            _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                _vm._s(_vm.$moneyFormat(_vm.orderMoney.day7))
                              )
                            ])
                          ])
                        : _c("div", { staticClass: "item-amount" }, [
                            _vm._v("*****")
                          ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("近7日成交金额")
                      ])
                    ]),
                    _c("div", { staticClass: "item item3" }, [
                      _vm.isClick
                        ? _c("div", { staticClass: "item-amount" }, [
                            _c("div", { staticClass: "item-symbol" }, [
                              _vm._v("￥")
                            ]),
                            _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                _vm._s(_vm.$moneyFormat(_vm.orderMoney.day30))
                              )
                            ])
                          ])
                        : _c("div", { staticClass: "item-amount" }, [
                            _vm._v("*****")
                          ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("近30日成交金额")
                      ])
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm.navIndex === 1
            ? _c("div", { staticClass: "right" }, [
                _vm.isClick
                  ? _c(
                      "div",
                      { staticClass: "blue text-center right-amount" },
                      [
                        _c(
                          "span",
                          { staticClass: "f-arial fb right-amount-num" },
                          [
                            _vm._v(
                              _vm._s(_vm.$moneyFormat(_vm.orderNum.sumNum, 0))
                            )
                          ]
                        )
                      ]
                    )
                  : _c("div", { staticClass: "text-center right-amount" }, [
                      _vm._v("*****")
                    ]),
                _c("div", { staticClass: "gray6 text-center right-text" }, [
                  _vm._v("累计订单量（笔）")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "gray6 right-items",
                    class: "items" + _vm.navIndex
                  },
                  [
                    _c("div", { staticClass: "item item0" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                _vm._s(_vm.$moneyFormat(_vm.orderNum.today, 0))
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("今日成交订单")
                      ])
                    ]),
                    _c("div", { staticClass: "item item1" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$moneyFormat(_vm.orderNum.yesterday, 0)
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("昨日成交订单")
                      ])
                    ]),
                    _c("div", { staticClass: "item item2" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                _vm._s(_vm.$moneyFormat(_vm.orderNum.day7, 0))
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("近7日成交订单")
                      ])
                    ]),
                    _c("div", { staticClass: "item item3" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                _vm._s(_vm.$moneyFormat(_vm.orderNum.day30, 0))
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("近30日成交订单")
                      ])
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm.navIndex === 2
            ? _c("div", { staticClass: "right" }, [
                _vm.isClick
                  ? _c(
                      "div",
                      { staticClass: "blue text-center right-amount" },
                      [
                        _c(
                          "span",
                          { staticClass: "f-arial fb right-amount-num" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$moneyFormat(_vm.orderVisitor.sumNum, 0)
                              )
                            )
                          ]
                        )
                      ]
                    )
                  : _c("div", { staticClass: "text-center right-amount" }, [
                      _vm._v("*****")
                    ]),
                _c("div", { staticClass: "gray6 text-center right-text" }, [
                  _vm._v("累计访客人数（人）")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "gray6 right-items",
                    class: "items" + _vm.navIndex
                  },
                  [
                    _c("div", { staticClass: "item item0" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$moneyFormat(_vm.orderVisitor.today, 0)
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("今日访客人数")
                      ])
                    ]),
                    _c("div", { staticClass: "item item1" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$moneyFormat(
                                      _vm.orderVisitor.yesterday,
                                      0
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("昨日访客人数")
                      ])
                    ]),
                    _c("div", { staticClass: "item item2" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$moneyFormat(_vm.orderVisitor.day7, 0)
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("近7日访客人数")
                      ])
                    ]),
                    _c("div", { staticClass: "item item3" }, [
                      _c("div", { staticClass: "item-amount" }, [
                        _vm.isClick
                          ? _c("div", { staticClass: "f-arial item-num" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$moneyFormat(_vm.orderVisitor.day30, 0)
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("div", [_vm._v("*****")])
                      ]),
                      _c("div", { staticClass: "item-text" }, [
                        _vm._v("近30日访客人数")
                      ])
                    ])
                  ]
                )
              ])
            : _vm._e()
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }